import circleCheckFilledIcon from "@tabler/icons/filled/circle-check.svg";
import circleCheckOutlineIcon from "@tabler/icons/outline/circle-check.svg";
import React from "react";

import { HStack, Icon, Text } from "@/components/ui";
import { cn } from "@/utils/cn";

interface ValidationCheckmarkProps {
  isValid: boolean;
  text: string;
}

const ValidationCheckmark = ({ isValid, text }: ValidationCheckmarkProps) => {
  return (
    <HStack alignItems="center" space={2} data-testid="validation-checkmark">
      <Icon
        src={isValid ? circleCheckFilledIcon : circleCheckOutlineIcon}
        className={cn("size-5", {
          "text-gray-400 dark:text-gray-800": !isValid,
          "text-primary-500 dark:text-primary-400": isValid,
        })}
      />

      <Text theme="muted" size="sm">
        {text}
      </Text>
    </HStack>
  );
};

export default ValidationCheckmark;
